import { AxiosError } from 'axios';

import {
  axiosInstanceForPublicAPIWithAuth,
  axiosInstanceForTenantAPI,
} from '../assets/utils/axiosInstance';
import {
  InvestigatorNoteCategory,
  InvestigatorNoteCategoryAPIResponse,
} from '../interfaces/InvestigatorNotes';

interface IInvestigatorNotesServices {
  fetchNotesCategory: (
    page?: number,
  ) => Promise<InvestigatorNoteCategoryAPIResponse>;
  createNoteCategory: (name: string) => Promise<InvestigatorNoteCategory>;
  deleteNoteCategory: (categoryID: number) => Promise<void>;
  updateInternalCommentCategory: (
    reportID: string,
    internalCommentID: string,
    categoryID: number | null,
  ) => Promise<void>;
}

const investigatorNotesServices: IInvestigatorNotesServices = {
  fetchNotesCategory: async (page) => {
    try {
      const response =
        await axiosInstanceForPublicAPIWithAuth().get<InvestigatorNoteCategoryAPIResponse>(
          `/note-categories?page=${page ?? 1}`,
        );

      return response.data;
    } catch (error) {
      const axiosError = error as AxiosError;
      throw axiosError;
    }
  },
  createNoteCategory: async (name: string) => {
    try {
      const response = await axiosInstanceForPublicAPIWithAuth().post(
        '/note-categories',
        { name },
      );
      return response.data;
    } catch (error) {
      const axiosError = error as AxiosError;
      throw axiosError;
    }
  },
  deleteNoteCategory: async (categoryID: number) => {
    try {
      const response = await axiosInstanceForPublicAPIWithAuth().delete(
        `/note-categories/${categoryID}`,
      );
      return response.data;
    } catch (error) {
      const axiosError = error as AxiosError;
      throw axiosError;
    }
  },
  updateInternalCommentCategory: async (
    reportID: string,
    internalCommentID: string,
    categoryID: number | null,
  ) => {
    try {
      const response = await axiosInstanceForTenantAPI().patch(
        `/report/${reportID}/internal-comments/${internalCommentID}`,
        {
          category: categoryID,
        },
      );
      return response.data;
    } catch (error) {
      const axiosError = error as AxiosError;
      throw axiosError;
    }
  },
};

export default investigatorNotesServices;
